export default "__VITE_ASSET__Dodll$I2__"